module.exports = __webpack_public_path__ + "img/movie-1.915b621f.png";